module.exports = __webpack_public_path__ + "static/report_builder_spreadsheep-6d121050f641d87205ea0d70942ba87b.gif";